import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(8);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最新吃瓜资讯
            </h2>
            <p className="text-sm text-foreground-600">每日更新，一手吃瓜不落伍</p>
          </div>
          <Link
            to="/category/wanghong-tafang"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <article key={article.id} className="group">
              <Link
                to={`/article/${article.id}`}
                className="block cursor-pointer"
              >
                <div className="relative aspect-[16/11] rounded-xl overflow-hidden mb-3">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {article.isTrending && (
                    <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-accent-500 text-background-50 text-[10px] font-medium">
                      <i className="ri-fire-line text-xs"></i>
                      热榜
                    </span>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>

                <span className="inline-block text-[11px] font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded mb-2">
                  {article.category}
                </span>

                <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2">
                  {article.title}
                </h3>

                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>

                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {article.comments.toLocaleString()}
                  </span>
                  <span className="ml-auto">{article.publishDate}</span>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/wanghong-tafang"
            className="inline-flex items-center gap-1 px-5 py-2.5 bg-background-100 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部吃瓜资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}